import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressSpinnerService } from '../../components/progress-spinner/progress-spinner.service';
import { ProductsExportService } from '../../../api/services/products-export.service';
import { CoreComponent } from '../../core.component';
import { PublicProductDto } from '../../../api/models/public-product-dto';

@Component({
  selector: 'price-list',
  templateUrl: './prices.component.html',
  styleUrls: ['./prices.component.scss'],
})
export class PricesComponent extends CoreComponent implements OnInit {
  products!: PublicProductDto[];
  tiles!: PublicProductDto[];
  tilesEvent = new EventEmitter<PublicProductDto[]>();
  rainSystemEvent = new EventEmitter<PublicProductDto[]>();
  accessoriesEvent = new EventEmitter<PublicProductDto[]>();

  constructor(
    public productsExportService: ProductsExportService,
    public dialog: MatDialog,
    public progressSpinnerService: ProgressSpinnerService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.progressSpinnerService.openProgressSpinner();
    this.productsExportService.productsExportControllerGetProductsWithPrice().subscribe((response: any) => {
      if (response.results.length > 0) {
        this.products = response.results;
        this.tiles = this.products.filter((product) => product.type === 'tile');
        this.tilesEvent.next(this.products.filter((product) => product.type === 'tile'));
        this.rainSystemEvent.next(this.products.filter((product) => product.type === 'rainSystem'));
        this.accessoriesEvent.next(
          this.products.filter(
            (product) => product.type === 'accessory' || product.type === ('simple-accessory' as any),
          ),
        );
        this.progressSpinnerService.closeProgressSpinner();
      }
    });
  }
}
